interface ReorderableLayer {
  id: number;
  groupId?: number | null;
}

/**
 * Index at which a dragged layer is spliced into its target container (the
 * over layer's container with the dragged layer already removed).
 *
 * Dropping on a layer below you inside the same container must land AFTER it
 * (arrayMove semantics). Indexing into the list with the dragged layer removed
 * lands one slot short, which made a one-step move down a no-op. Moves up and
 * cross-container drops land before the over layer.
 */
export function layerDropIndex<T extends ReorderableLayer>(layers: T[], active: T, over: T): number {
  const targetGroupId = over.groupId ?? null;
  const container = layers.filter((layer) => (layer.groupId ?? null) === targetGroupId);
  const withoutActive = container.filter((layer) => layer.id !== active.id);
  const overIndex = withoutActive.findIndex((layer) => layer.id === over.id);
  if (overIndex < 0) return withoutActive.length;

  const sameContainer = (active.groupId ?? null) === targetGroupId;
  const movingDown = sameContainer && container.findIndex((layer) => layer.id === active.id) < container.findIndex((layer) => layer.id === over.id);
  return movingDown ? overIndex + 1 : overIndex;
}
